// removed by extract-text-webpack-plugin
module.exports = {"hidden":"_2o8dx","visuallyhidden":"_1R9Ns","hide-text":"_2BWnY","center":"_3v-Ch","noprint":"CoKMs","text":"_2gLYl"};


/*****************
 ** WEBPACK FOOTER
 ** ./themes/ui-text/styles/default.scss
 ** module id = 1023
 ** module chunks = 2
 **/